import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProjectsSchemaIcon } from '@repo/custom-icons';
export const NoDependenciesWarning = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center justify-center gap-4 h-[200px] p-8 rounded-lg border border-secondary bg-primary",
        children: [
            /*#__PURE__*/ _jsx(ProjectsSchemaIcon, {
                className: "text-primary"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-secondary text-sm",
                children: "There are currently no dependencies"
            })
        ]
    });
};
